// extracted by mini-css-extract-plugin
module.exports = {"comp":"Q_comp__or12i"};